import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import {
  EXCEL_PREVIEW_CLASS,
  GENERIC_PREVIEW_CLASS,
  GENERIC_PREVIEW_CLASS_NAME,
  LOADING_CLASS,
  PDF_PREVIEW_CLASS,
  PREVIEW_CLASS,
  SPACER_GIF,
  VIDEO_PREVIEW_CLASS,
  WORD_PREVIEW_CLASS,
} from './FileInputClasses';
import makeSafeForID from './makeSafeForID';

const fileNameToPreviewClass = (fileName: string): string => {
  if (fileName.includes('.pdf')) {
    return PDF_PREVIEW_CLASS;
  }
  if (fileName.includes('.doc') || fileName.includes('.pages')) {
    return WORD_PREVIEW_CLASS;
  }
  if (fileName.includes('.xls') || fileName.includes('.numbers')) {
    return EXCEL_PREVIEW_CLASS;
  }
  if (fileName.includes('.mov') || fileName.includes('.mp4')) {
    return VIDEO_PREVIEW_CLASS;
  }
  return GENERIC_PREVIEW_CLASS;
};

const FilePreview = ({ file }: { file: File }): JSX.Element => {
  const [status, setStatus] = useState<'loading' | 'error' | 'done'>('loading');
  const [imageSrc, setImageSrc] = useState<string>(SPACER_GIF);
  const imageId = makeSafeForID(file.name);
  useEffect(() => {
    const reader = new FileReader();
    reader.onloadend = (): void => {
      // reader.result will be a string at this point.
      // See: https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
      setImageSrc(reader.result as string);
      setStatus('done');
    };
    reader.readAsDataURL(file);
    return (): void => reader.abort();
  }, [file]);
  const onError = (): void => {
    setImageSrc(SPACER_GIF);
    setStatus('error');
  };
  return (
    <div className={PREVIEW_CLASS}>
      <img
        id={imageId}
        src={imageSrc}
        alt=""
        onError={onError}
        className={classNames(GENERIC_PREVIEW_CLASS_NAME, {
          [LOADING_CLASS]: status === 'loading',
          [fileNameToPreviewClass(file.name)]: status === 'error',
        })}
      />
      {file.name}
    </div>
  );
};

export default FilePreview;
